import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const useSlackIntegrationPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  const breadcrumbs = [
    {
      link: url('SettingsPage'),
      name: intl.formatMessage(messages.settingsTitle),
    },
    {
      link: url('IntegrationsPage'),
      name: intl.formatMessage(messages.integrationsTitle),
    },
    {
      name: intl.formatMessage(messages.pageTitle),
      escapeCaseFormatting: true,
    },
  ]

  return {
    breadcrumbs,
  }
}
